
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Medical History Component
 * @param response has the backend
 * Medical History component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
     let result :any = {
        getdeptinfo:[],
        error:undefined
    }

    const { log } = context;
    let responsearray = [];
    if (response && response.status >= 400) {
        result.error=response;
     }
    if (response?.length > 0) {
      
        result.getdeptinfo=response;
    }
    log.debug(
        "ccw-gadget,getdeptinfo-athena",
        "getdeptinfo-athena transformation response ", {
        result
    });
    return result;
}